<template>
    <nav class="lg:w-9/12 w-10/12 mx-auto text-gray-100 py-5" role="navigation">
        <div class="container mx-auto flex flex-wrap items-center md:flex-no-wrap">
            <div class="mr-auto md:hidden">
               <span class="font-bold text-xl">DEBARSHI DAS</span>
            </div>
            <div class="ml-auto md:hidden">
                <button class="flex focus:outline-none items-center px-3 py-2 border rounded" @click="showNav = !showNav">
                    <svg class="h-3 w-3" viewBox="0 0 20 20" fill="white" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"/>
                    </svg>
                </button>
            </div>
            <div class="w-full hidden md:block md:w-auto md:flex-grow md:flex md:items-center">
                <ul class="flex flex-col mt-4 pt-4 border-t md:flex-row md:items-center md:-mx-3 md:mt-0 md:pt-0 md:mr-4 lg:mr-8 md:border-0">
                    <li>
                        <a class="block pr-4 py-1 md:p-2 lg:px-4" href="#intro" v-smooth-scroll>INTRO</a>
                    </li>
                    <li>
                        <a class="block pr-4 py-1 md:p-2 lg:px-4" href="#education" v-smooth-scroll>EDUCATION</a>
                    </li>
                    <li>
                        <a class="block pr-4 py-1 md:p-2 lg:px-4" href="#experience" v-smooth-scroll>EXPERIENCE</a>
                    </li>
                    <li>
                        <a class="block pr-4 py-1 md:p-2 lg:px-4" href="#skills" v-smooth-scroll>SKILLS</a>
                    </li>
                    <li>
                        <a class="block pr-4 py-1 md:p-2 lg:px-4" href="#projects" v-smooth-scroll>WORKS</a>
                    </li>
                    <li>
                        <a class="block pr-4 py-1 md:p-2 lg:px-4" href="#contact" v-smooth-scroll>CONTACT</a>
                    </li>
                </ul>
            </div>
            <div class="w-full" v-if="showNav">
                <ul class="flex flex-col mt-4 pt-4 border-t md:flex-row md:items-center md:-mx-3 md:mt-0 md:pt-0 md:mr-4 lg:mr-8 md:border-0">
                    <li>
                        <a class="block pr-4 py-1 md:p-2 lg:px-4" href="#">INTRO</a>
                    </li>
                    <li>
                        <a class="block pr-4 py-1 md:p-2 lg:px-4" href="#">EDUCATION</a>
                    </li>
                    <li>
                        <a class="block pr-4 py-1 md:p-2 lg:px-4" href="#">EXPERIENCE</a>
                    </li>
                    <li>
                        <a class="block pr-4 py-1 md:p-2 lg:px-4" href="#">SKILLS</a>
                    </li>
                    <li>
                        <a class="block pr-4 py-1 md:p-2 lg:px-4" href="#">WORKS</a>
                    </li>
                    <li>
                        <a class="block pr-4 py-1 md:p-2 lg:px-4" href="#">CONTACT</a>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>


<script>
export default {
    data: function(){
        return {
            showNav: false
        }
    }
}
</script>